import RestfulProvider from "../globals/RestfulProvider";

const headers = {
  Accept: "application/json",
  "Content-type": "application/json",
  isAuthenticated: true,
};
const subUrllocal = "/api/v1/historicalContractSetting";
const localurl = "/api/v1";
class stffService {
  getHistoricalListAPI = (data) =>
    RestfulProvider.post(`${subUrllocal}/historical_list`, data, headers);
  createHistoricalContract = (data) =>
    RestfulProvider.formDatapost(
      `${subUrllocal}/historical_create`,
      data,
      headers
    );
  deleteTaskApi = (data) =>
    RestfulProvider.post(`${subUrllocal}/historical_delete`, data, headers);
  ResetpasswordApi = (data) =>
    RestfulProvider.post(`${subUrllocal}/updateUserProfile`, data, headers);
  getHistoricaljsondataAPI = (data) =>
    RestfulProvider.post(`${subUrllocal}/getforms`, data, headers);
  updateHistoricaljsondataAPI = (data) =>
    RestfulProvider.post(`${subUrllocal}/updateDefaultFields`, data, headers);
  CreatehistoricalContractsAPI = (data) =>
    RestfulProvider.formDatapost(`${subUrllocal}/submit`, data, headers);
  GetbufferdatafromUrlAPI = (data) =>
    RestfulProvider.downloadMethod(`${localurl}/content/getpdf`, data, headers);
  CreateBulkHistoricalAPI = (data) =>
    RestfulProvider.formDatapost(`${subUrllocal}/bulkpdfupload`, data, headers);
  getExcelforBulkHistoricalAPI = (data) =>
    RestfulProvider.downloadMethod(`${subUrllocal}/exportExcel`, data, headers);
  getImportsListAPI = (data) =>
    RestfulProvider.post(`${subUrllocal}/historicalInstance`, data, headers);
  getImportDetailsAPI = (data) =>
    RestfulProvider.post(`${subUrllocal}/historicalInstanceDetail`, data, headers);
  getImportItemByIdAPI = (data) =>
    RestfulProvider.post(
      `${subUrllocal}/historicalInstanceData`,
      data,
      headers
    );
  submitFileUploadExcelAPI = (data) =>
    RestfulProvider.post(`${subUrllocal}/bulkUpload`, data, headers);
  getconnectwithGoogledriveAPI = (data) =>
    RestfulProvider.get(
      `${subUrllocal}/google/:${data?.companyId}`,
      data,
      headers
    );
  getTokenforGoogledriveAPI = (data) =>
    RestfulProvider.post(`${subUrllocal}/getToken`, data, headers);
  SendfilesandfolderAPI = (data) =>
    RestfulProvider.post(`${subUrllocal}/sendfilesandfolders`, data, headers);
  getLegalAssociatesAPI = (data) =>
    RestfulProvider.post(`${subUrllocal}/getLegalAssociates`, data, headers);
  getAssignTasktoLegalAssociatesAPI = (data) =>
    RestfulProvider.post(`${subUrllocal}/assignContract`, data, headers);
  getReAssignTasktoLegalAssociatesAPI = (data) =>
    RestfulProvider.post(`${subUrllocal}/reassignContract`, data, headers);
  getDistributedcontractDetailsAPI = (data) =>
    RestfulProvider.post(`${subUrllocal}/distributeContracts`, data, headers);
  unassignContractToLegalAssociateAPI = (data) =>
    RestfulProvider.post(`${subUrllocal}/reassignContract`, data, headers);
  getBulkAssignTasktoLegalAssociatesAPI = (data) =>
    RestfulProvider.post(`${subUrllocal}/bulkAssignContracts`, data, headers);
  getBulkReAssignTasktoLegalAssociatesAPI = (data) =>
    RestfulProvider.post(`${subUrllocal}/bulkReassignContracts`, data, headers);
  getDetailsFillwithAIAPI = (data) =>
    RestfulProvider.post(`${subUrllocal}//fillContract`, data, headers);
  saveCompanyPromptAPI = (data) =>
    RestfulProvider.post(`${subUrllocal}/saveCompanyPrompt`, data, headers);
  getBulkAssignedDataAPI = (data) =>
    RestfulProvider.post(`${subUrllocal}/getAssignmentData`, data, headers);
  EditPromptAPI = (data) =>
    RestfulProvider.post(`${subUrllocal}/updatePrompt`, data, headers);

  GetcsvforparticularfileAPI = (data) =>
    RestfulProvider.downloadMethod(`${subUrllocal}/getcsv`, data, headers);
  findmissingcontractAPI = (data) =>
    RestfulProvider.post(`${subUrllocal}/findmissingcontract`, data, headers);
  findDuplicatesContractAPI = (data) =>
    RestfulProvider.post(`${subUrllocal}/duplicate`, data, headers);
  getDuplicatesContractListsAPI = (data) =>
    RestfulProvider.post(
      `${subUrllocal}/duplicateContractsList`,
      data,
      headers
    );
  deleteDuplicatesContractsAPI = (data) =>
    RestfulProvider.post(`${subUrllocal}/duplicatedelete`, data, headers);
  getHistoricalDetailsAPI = (data) =>
    RestfulProvider.post(`${subUrllocal}/historical_details`, data, headers);
}
// eslint-disable-next-line
export default new stffService();

// getImportsListAPI = (data) =>
//   RestfulProvider.post(`${subUrllocal}/getBulkImportList`, data, headers);
// getImportItemByIdAPI= (data) =>
//   RestfulProvider.post(`${subUrllocal}/getContractsByGroup`, data, headers);
